import React, { useMemo ,useEffect} from 'react';
import {
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
} from '@ant-design/icons';
import { Button, Divider, notification, Space } from 'antd';
const Context = React.createContext({ name: 'Default' });
const NotificationThing = (props) => {
  const [api, contextHolder] = notification.useNotification();
  useEffect(() => {
    openNotification(props.direction)
  }, [])
  
  const openNotification = placement => {
    
      if(props.type == 'success'){
        api.success({
            message: `${props.topMessage}`,
            description: <Context.Consumer>{({ name }) => `${props.bottomMessage}`}</Context.Consumer>,
            placement,
            showProgress:props.showNotificationProgress,
            pauseOnHover:props.pauseNotificationOnHover
            
          });
    }else  if(props.type == 'error'){
        api.error({
            message: `${props.topMessage}`,
            description: <Context.Consumer>{({ name }) => `${props.bottomMessage}`}</Context.Consumer>,
            placement,
          });
    }else  if(props.type == 'info'){
        api.info({
            message: `${props.topMessage}`,
            description: <Context.Consumer>{({ name }) => `${props.bottomMessage}`}</Context.Consumer>,
            placement,
          });
    }else  if(props.type == 'warning'){
        api.warning({
            message: `${props.topMessage}`,
            description: <Context.Consumer>{({ name }) => `${props.bottomMessage}`}</Context.Consumer>,
            placement,
          });
    }else {
        api.open({
            message: `${props.topMessage}`,
            description: <Context.Consumer>{({ name }) => `${props.bottomMessage}`}</Context.Consumer>,
            placement,
          });
    }
   
  };
  const contextValue = useMemo(() => ({ name: 'Ant Design' }), []);
  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
    </Context.Provider>
  );
};
export default NotificationThing;